

import * as React from 'react';
import styled from 'styled-components';

export const getDateFormat = (includeTime?: boolean, formatString?: string) => {
  if (formatString) {
    return formatString;
  }

  if (includeTime) {
    return 'MM-DD-YYYY hh:mm A';
  }
  return 'MM-DD-YYYY';
};

type FormGroupProps = {
  label: string,
  labelPosition?: 'top' | 'left',
  children: React.ReactNode,
};

const DatePickerWrapper = styled.div<{ labelPosition?: 'top' | 'left' }>`
  display: flex;
  padding-left: 0;
  flex-direction: ${props =>
    props.labelPosition === 'left' ? 'row' : 'column'};
`;

export const DateTimePickerFormGroup = (props: FormGroupProps) => {
  const { labelPosition } = props;

  return (
    <>
      <div className="form-group row">
        <DatePickerWrapper
          className="date-picker-wrapper"
          labelPosition={labelPosition}
        >
          <label className="date-picker-label">{props.label}</label>
          {props.children}
        </DatePickerWrapper>
      </div>
    </>
  );
};

export const CalendarButton = () => (
  <span className="input-group-btn">
    <button type="button" className="btn btn-default">
      <i className="sprites sprite-calendar-gray"></i>
    </button>
  </span>
);
